<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="模块">
					<el-input v-model="filters.module"></el-input>
                </el-form-item>
				<el-form-item label="请求">
					<el-input v-model="filters.actionInput"></el-input>
                </el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" unlink-panels :picker-options="pickerOptions" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<form-query-button  @select-type="getOptLog" >  </form-query-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="records" highlight-current-row v-loading="listLoading"  style="width: 100%;" border :height="formHeight" size="mini">
			<el-table-column type="index" label="序号">
			</el-table-column>
            <el-table-column prop="operationModule" label="模块" >
			</el-table-column>
            <el-table-column prop="operationEvents" label="请求" >
			</el-table-column>
            <el-table-column prop="operationData" label="参数" min-width="220">
			</el-table-column>
			<el-table-column prop="operationStatus" label="结果" >
				<template slot-scope="scope">
					<span v-if="scope.row.operationStatu">成功</span>
					<span v-else>失败</span>
				</template>
			</el-table-column>
            <el-table-column prop="operationUsername" label="操作人">
			</el-table-column>
			<el-table-column prop="operationIp" label="IP">
			</el-table-column>
			<el-table-column prop="addTime" label="操作时间"   sortable>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[20,50,100,200]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>
	</section>
</template>

<script>
	import util from '../../common/js/util';
	import {formatDate} from '../../../static/fun.js';
	import {getOptLog}	from '../../api/api';

	import FormQueryButton from '../../components/myButton/FormQueryButton.vue'

	export default {
	components: { FormQueryButton },
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
                    UserId: '',
					param:'',
					actionInput:'',
					module:''
				},
				users: [],
				records:[],
				total: 0,
               	page:1,
				pageSize:50,
				formHeight:0,
				listLoading: false,
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page=val;
				this.getOptLog();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getOptLog();
			},
			//获取数据列表
			getOptLog() {
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
                }
				let para = {
                    page: this.page,
                    pageSize:this.pageSize,
					operationModule: this.filters.module,
					operationEvents: this.filters.actionInput,	
					startTime: starttime,
                    endTime: endtime
				};
                this.listLoading = true;
				getOptLog(para).then((res) => {
                    this.listLoading = false;
					this.total = res.data.data.total;
					this.records = res.data.data.records;
				});
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			var timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)

			var end = new Date();
			var start = new Date();
			//设置不同的时间区间
			start.setTime(start.setDate(start.getDate()-1));
            this.filters.time= [formatDate(start), formatDate(end)];
			this.getOptLog();
		}
	}

</script>

<style scoped>
	#smallMapCon{
		float: left;
		width: 45%;
		height: 350px;
	}
	#smallMap{
		width: 100%;
		height: 300px;
	}
	.dialog-footer{
		text-align: right;
	}
	.isShow{
		display: block;
	}
	.notShow{
		display: none;
	}
</style>


// WEBPACK FOOTER //
// OptLog.vue?c4c7c108